document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('product_slider')) {
    let main = new Splide('#product_slider', {
        start: 0,
        type: 'slide',
        rewind: false,
        pagination: true,
        perPage: 1,
        snap: true,
        arrows: true,
        gap: 0,
        lazyLoad: 'nearby',
        cover: false,
        height: '850px', // Height for laptop and larger screens
        breakpoints: {

        '768': { 
            height: 'auto',
            rewind: true,
            rewindByDrag: true,
            type: 'loop',
            drag: 'free',
            flickPower: 300,
            focus: 'center',
        },
        },
    });

        main.on('moved', function() {
            let lastSlide = document.querySelector('.splide__slide:last-child');
            if (main.index === main.length - 1) {
                lastSlide.style.paddingRight = '0';
            } else {
                lastSlide.style.paddingRight = '';
            }
        });

        main.mount();

        // Only initialize and run the thumbnail slider if there is more than one slide in the main slider
        if (main.length > 1) {
            let thumbnails = new Splide('#thumbnail-slider', {
                type: 'slide',
                start: 1,
                gap: 10,
                perPage: 4,
                easing: 'ease',
                pagination: false,
                cover: true,
                isNavigation: true,
                arrows: false,
                fixedWidth: 220,
                fixedHeight: 330,
                direction: 'ttb',
                height: 330,
                wheel: true,
                wheelSleep: 500,
                speed: 1000,
                rewind: true,
                lazyLoad: 'nearby',
                breakpoints: {
                    '768': {
                        destroy: true,
                    }
                },
            });

            thumbnails.mount();

            main.sync(thumbnails);


        }

    }
 

});
document.addEventListener('DOMContentLoaded', function () {
    const gallery = document.getElementById('product_slider');
    if (gallery) {
        new SimpleLightbox('#product_slider a', {
            history: true,
            alertError: false,
            additionalHtml: false,
            loop: true,
            overlayOpacity: 1,
            doubleTapZoom: 2,
            fadeSpeed: 50,
            animationSpeed: 50,
            swipeClose: false,
            enableZoom: true
        });
    }
});